<input
  class="email-input"
  type="email"
  inputmode="email"
  autocomplete="off"
  [ngClass]="{
    'error-border': error,
    disabled: disabled
  }"
  [attr.id]="controlId"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)"
  (blur)="handleBlur()" />
